var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgContent3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 831,
    height: 166,
    viewBox: "0 0 831 166",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_3535",
    "data-name": "\\uADF8\\uB8F9 3535",
    transform: "translate(-587 -3163.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1472",
    "data-name": "\\uADF8\\uB8F9 1472",
    transform: "translate(-107.236 1145.5)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "\\uC704\\uC0DD\\uC2B5\\uAD00",
    transform: "translate(900.236 2103)",
    fontSize: 16,
    fontFamily: "NotoSansCJKkr-Medium, Noto Sans CJK KR",
    fontWeight: 500,
    letterSpacing: "-0.05em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\uC704\uC0DD\uC2B5\uAD00"))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1471",
    "data-name": "\\uADF8\\uB8F9 1471",
    transform: "translate(-300.236 1145.5)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "\\uC2DD\\uC0AC_\\uC2B5\\uAD00",
    "data-name": "\\uC2DD\\uC0AC \\uC2B5\\uAD00",
    transform: "translate(900.236 2103)",
    fontSize: 16,
    fontFamily: "NotoSansCJKkr-Medium, Noto Sans CJK KR",
    fontWeight: 500,
    letterSpacing: "-0.05em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\uC2DD\uC0AC \uC2B5\uAD00"))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1474",
    "data-name": "\\uADF8\\uB8F9 1474",
    transform: "translate(73.764 1145.5)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "\\uBC14\\uB978\\uB9D0_\\uC2B5\\uAD00",
    "data-name": "\\uBC14\\uB978\\uB9D0 \\uC2B5\\uAD00",
    transform: "translate(900.236 2103)",
    fontSize: 16,
    fontFamily: "NotoSansCJKkr-Medium, Noto Sans CJK KR",
    fontWeight: 500,
    letterSpacing: "-0.05em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\uBC14\uB978\uB9D0 \uC2B5\uAD00"))), /*#__PURE__*/React.createElement("g", {
    id: "\\uAD6C\\uC131_\\uC694\\uC18C_29_1",
    "data-name": "\\uAD6C\\uC131 \\uC694\\uC18C 29 \\u2013 1",
    transform: "translate(600.309 3173.5)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "\\uD0C0\\uC6D0_22",
    "data-name": "\\uD0C0\\uC6D0 22",
    cx: 9.794,
    cy: 9.794,
    rx: 9.794,
    ry: 9.794,
    transform: "translate(17.859 6.338)",
    fill: "none",
    stroke: "#f69f30",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "\\uD0C0\\uC6D0_23",
    "data-name": "\\uD0C0\\uC6D0 23",
    cx: 16.131,
    cy: 16.131,
    rx: 16.131,
    ry: 16.131,
    transform: "translate(11.522 0)",
    fill: "none",
    stroke: "#434343",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_755",
    "data-name": "\\uD328\\uC2A4 755",
    d: "M369.885,255.313a4.609,4.609,0,0,1-9.218,0c0-2.545,2.063-6.913,4.609-6.913S369.885,252.768,369.885,255.313Z",
    transform: "translate(-360.667 -248.4)",
    fill: "none",
    stroke: "#434343",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_46",
    "data-name": "\\uC120 46",
    y2: 9.218,
    transform: "translate(4.609 10.947)",
    fill: "none",
    stroke: "#434343",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_1380",
    "data-name": "\\uC0AC\\uAC01\\uD615 1380",
    width: 3.457,
    height: 16.046,
    rx: 1.728,
    transform: "translate(2.88 19.588)",
    fill: "none",
    stroke: "#434343",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_47",
    "data-name": "\\uC120 47",
    y2: 17.86,
    transform: "translate(50.794 1.729)",
    fill: "none",
    stroke: "#434343",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_1381",
    "data-name": "\\uC0AC\\uAC01\\uD615 1381",
    width: 3.457,
    height: 16.046,
    rx: 1.728,
    transform: "translate(49.066 19.588)",
    fill: "none",
    stroke: "#434343",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_756",
    "data-name": "\\uD328\\uC2A4 756",
    d: "M440.787,251.048v5.626a4.9,4.9,0,0,1-4.9,4.9h0a4.9,4.9,0,0,1-4.9-4.9v-5.626",
    transform: "translate(-385.096 -249.32)",
    fill: "none",
    stroke: "#434343",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1476",
    "data-name": "\\uADF8\\uB8F9 1476",
    transform: "translate(256.764 1145.5)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "\\uCC45\\uC77D\\uAE30_\\uC2B5\\uAD00",
    "data-name": "\\uCC45\\uC77D\\uAE30 \\uC2B5\\uAD00",
    transform: "translate(900.236 2103)",
    fontSize: 16,
    fontFamily: "NotoSansCJKkr-Medium, Noto Sans CJK KR",
    fontWeight: 500,
    letterSpacing: "-0.05em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\uCC45\uC77D\uAE30 \uC2B5\uAD00"))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1478",
    "data-name": "\\uADF8\\uB8F9 1478",
    transform: "translate(371.764 1144.5)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "\\uC815\\uB9AC\\uC2B5\\uAD00",
    transform: "translate(1005.236 2104)",
    fontSize: 16,
    fontFamily: "NotoSansCJKkr-Medium, Noto Sans CJK KR",
    fontWeight: 500,
    letterSpacing: "-0.05em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -28.24,
    y: 0
  }, "\uC815\uB9AC\uC2B5\uAD00"))), /*#__PURE__*/React.createElement("g", {
    id: "\\uAD6C\\uC131_\\uC694\\uC18C_31_1",
    "data-name": "\\uAD6C\\uC131 \\uC694\\uC18C 31 \\u2013 1",
    transform: "translate(984 3167.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_766",
    "data-name": "\\uD328\\uC2A4 766",
    d: "M295.111,385H266.062a2.794,2.794,0,0,0-2.794,2.794v19.019a2.794,2.794,0,0,0,2.794,2.794H286.93l7.954,5.091a.451.451,0,0,0,.692-.425l-.467-4.666h0a2.794,2.794,0,0,0,2.794-2.794V387.794A2.794,2.794,0,0,0,295.111,385Z",
    transform: "translate(-250.208 -385)",
    fill: "none",
    stroke: "#484848",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "\\uD0C0\\uC6D0_34",
    "data-name": "\\uD0C0\\uC6D0 34",
    cx: 1.053,
    cy: 1.053,
    rx: 1.053,
    ry: 1.053,
    transform: "translate(21.357 11.094)",
    fill: "#484848"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "\\uD0C0\\uC6D0_35",
    "data-name": "\\uD0C0\\uC6D0 35",
    cx: 1.053,
    cy: 1.053,
    rx: 1.053,
    ry: 1.053,
    transform: "translate(28.636 11.094)",
    fill: "#484848"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "\\uD0C0\\uC6D0_36",
    "data-name": "\\uD0C0\\uC6D0 36",
    cx: 1.053,
    cy: 1.053,
    rx: 1.053,
    ry: 1.053,
    transform: "translate(35.915 11.094)",
    fill: "#484848"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_767",
    "data-name": "\\uD328\\uC2A4 767",
    d: "M247.406,440.465h14.658l-.033-.013a15.662,15.662,0,1,0-11.339-4.325l-4.859,3.534a.445.445,0,0,0,.262.8h1.312",
    transform: "translate(-245.649 -391.249)",
    fill: "#fff",
    stroke: "#484848",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_60",
    "data-name": "\\uC120 60",
    x2: 8.389,
    transform: "translate(6.908 27.963)",
    fill: "none",
    stroke: "#f69f30",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_61",
    "data-name": "\\uC120 61",
    x2: 17.337,
    transform: "translate(6.908 32.979)",
    fill: "none",
    stroke: "#f69f30",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_62",
    "data-name": "\\uC120 62",
    x2: 17.337,
    transform: "translate(6.908 37.993)",
    fill: "none",
    stroke: "#f69f30",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uAD6C\\uC131_\\uC694\\uC18C_33_1",
    "data-name": "\\uAD6C\\uC131 \\uC694\\uC18C 33 \\u2013 1",
    transform: "translate(1348.739 3167.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1486",
    "data-name": "\\uADF8\\uB8F9 1486",
    transform: "translate(5.287 30.174)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_1388",
    "data-name": "\\uC0AC\\uAC01\\uD615 1388",
    width: 22.977,
    height: 14.243,
    fill: "none",
    stroke: "#434343",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_1389",
    "data-name": "\\uC0AC\\uAC01\\uD615 1389",
    width: 22.977,
    height: 14.243,
    transform: "translate(22.977)",
    fill: "none",
    stroke: "#434343",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_1390",
    "data-name": "\\uC0AC\\uAC01\\uD615 1390",
    width: 29.187,
    height: 16.101,
    transform: "translate(13.67 14.073)",
    fill: "none",
    stroke: "#434343",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_772",
    "data-name": "\\uD328\\uC2A4 772",
    d: "M527.743,386.275l-15.434,14.073h30.869Z",
    transform: "translate(-499.479 -386.275)",
    fill: "none",
    stroke: "#f69f30",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uC0AC\\uAC01\\uD615_1391",
    "data-name": "\\uC0AC\\uAC01\\uD615 1391",
    d: "M4.968,0h0A4.968,4.968,0,0,1,9.936,4.968v3.7a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0v-3.7A4.968,4.968,0,0,1,4.968,0Z",
    transform: "translate(23.296 21.504)",
    fill: "none",
    stroke: "#434343",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_63",
    "data-name": "\\uC120 63",
    x2: 56.331,
    transform: "translate(0 44.417)",
    fill: "none",
    stroke: "#434343",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uAD6C\\uC131_\\uC694\\uC18C_30_1",
    "data-name": "\\uAD6C\\uC131 \\uC694\\uC18C 30 \\u2013 1",
    transform: "translate(796.383 3164.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_773",
    "data-name": "\\uD328\\uC2A4 773",
    d: "M156.894,404.328V391.454a2.848,2.848,0,0,1,2.848-2.848h.2a2.848,2.848,0,0,1,2.848,2.848v17.592",
    transform: "translate(-128.332 -380.745)",
    fill: "none",
    stroke: "#434343",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_774",
    "data-name": "\\uD328\\uC2A4 774",
    d: "M137.511,416.565c-1.677-2.268-6.549-3.069-8.891-2.306h0l-2.126-6.524a5.626,5.626,0,0,0-7.093-3.607h0a1.509,1.509,0,0,0-.968,1.9l3.4,10.439,1.7,5.229c1.348,4.138,5.8,7.972,9.934,6.623v8.251",
    transform: "translate(-118.358 -384.69)",
    fill: "none",
    stroke: "#434343",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_64",
    "data-name": "\\uC120 64",
    y2: 5.503,
    transform: "translate(29.742 46.381)",
    fill: "none",
    stroke: "#434343",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_775",
    "data-name": "\\uD328\\uC2A4 775",
    d: "M133.03,407.947V387.212a2.848,2.848,0,0,1,2.848-2.848h.2a2.848,2.848,0,0,1,2.848,2.848v9.73",
    transform: "translate(-122.155 -379.646)",
    fill: "none",
    stroke: "#434343",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_776",
    "data-name": "\\uD328\\uC2A4 776",
    d: "M140.985,400.1V380.848A2.848,2.848,0,0,1,143.833,378h.2a2.848,2.848,0,0,1,2.848,2.848v19.164",
    transform: "translate(-124.214 -378)",
    fill: "none",
    stroke: "#434343",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_777",
    "data-name": "\\uD328\\uC2A4 777",
    d: "M148.939,401.109V385.09a2.849,2.849,0,0,1,2.848-2.848h.2a2.848,2.848,0,0,1,2.848,2.848v17.591",
    transform: "translate(-126.273 -379.098)",
    fill: "none",
    stroke: "#434343",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_778",
    "data-name": "\\uD328\\uC2A4 778",
    d: "M169.738,414.922c-5.314.984-10.628-3.937-10.628-3.937s-5.314,4.92-10.629,3.937c0,0-5.314,17.714,10.629,22.634C175.052,432.635,169.738,414.922,169.738,414.922Z",
    transform: "translate(-125.934 -386.537)",
    fill: "#fff",
    stroke: "#434343",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_779",
    "data-name": "\\uD328\\uC2A4 779",
    d: "M172.616,392.848s-.917,4.586-4.586,5.5c3.669.917,4.586,5.5,4.586,5.5s.918-4.586,4.586-5.5C173.533,397.434,172.616,392.848,172.616,392.848Z",
    transform: "translate(-131.213 -381.843)",
    fill: "#fff",
    stroke: "#434343",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_780",
    "data-name": "\\uD328\\uC2A4 780",
    d: "M179.66,406.636s-.629,3.145-3.145,3.773c2.516.629,3.145,3.773,3.145,3.773s.629-3.144,3.144-3.773C180.288,409.781,179.66,406.636,179.66,406.636Z",
    transform: "translate(-133.409 -385.411)",
    fill: "#fff",
    stroke: "#434343",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_781",
    "data-name": "\\uD328\\uC2A4 781",
    d: "M157.316,427.183l3.915,3.425,4.893-6.85",
    transform: "translate(-128.441 -389.842)",
    fill: "#fff",
    stroke: "#f69f30",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uAD6C\\uC131_\\uC694\\uC18C_32_1",
    "data-name": "\\uAD6C\\uC131 \\uC694\\uC18C 32 \\u2013 1",
    transform: "translate(1161.439 3171.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1485",
    "data-name": "\\uADF8\\uB8F9 1485"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_768",
    "data-name": "\\uD328\\uC2A4 768",
    d: "M394.755,431.013s-3.621,1.519-10-.667c-6.623-2.267-19.337-1.289-19.337-1.289V396.781l4.89-.978,24.451,18.583Z",
    transform: "translate(-365.413 -391.891)",
    fill: "#fff",
    stroke: "#434343",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_769",
    "data-name": "\\uD328\\uC2A4 769",
    d: "M396.121,428.669s-1.956-3.912-7.824-4.89-17.606-.978-17.606-.978V390.525h16.1a9.326,9.326,0,0,1,9.327,9.327Z",
    transform: "translate(-366.779 -390.525)",
    fill: "#fff",
    stroke: "#434343",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_770",
    "data-name": "\\uD328\\uC2A4 770",
    d: "M405,431.013s3.621,1.519,10-.667c6.623-2.267,19.337-1.289,19.337-1.289V396.781l-4.89-.978L405,414.386Z",
    transform: "translate(-375.658 -391.891)",
    fill: "#fff",
    stroke: "#434343",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_771",
    "data-name": "\\uD328\\uC2A4 771",
    d: "M405,428.669s1.956-3.912,7.824-4.89,17.606-.978,17.606-.978V390.525h-16.1A9.326,9.326,0,0,0,405,399.852Z",
    transform: "translate(-375.658 -390.525)",
    fill: "#fff",
    stroke: "#434343",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_812",
    "data-name": "\\uD328\\uC2A4 812",
    d: "M1779.747-2266.421s3.009-6.553,16.884-3.7",
    transform: "translate(-1746.439 2276)",
    fill: "none",
    stroke: "#f69f30",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_813",
    "data-name": "\\uD328\\uC2A4 813",
    d: "M1779.747-2266.421s3.009-6.553,16.884-3.7",
    transform: "translate(-1746.439 2286)",
    fill: "none",
    stroke: "#f69f30",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_814",
    "data-name": "\\uD328\\uC2A4 814",
    d: "M1779.747-2266.421s3.009-6.553,16.884-3.7",
    transform: "translate(-1746.439 2281)",
    fill: "none",
    stroke: "#f69f30",
    strokeLinecap: "round",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("text", {
    id: "\\uC790\\uB9AC\\uC5D0_\\uC549\\uC544\\uC11C_\\uACE8\\uACE0\\uB8E8_\\uBA39\\uC5B4\\uC694",
    "data-name": "\\uC790\\uB9AC\\uC5D0 \\uC549\\uC544\\uC11C \\uACE8\\uACE0\\uB8E8 \\uBA39\\uC5B4\\uC694",
    transform: "translate(628 3285.5)",
    fill: "#484848",
    fontSize: 14,
    fontFamily: "NotoSansCJKkr-DemiLight, Noto Sans CJK KR DemiLight",
    fontWeight: 300
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -40.201,
    y: 0
  }, "\uC790\uB9AC\uC5D0 \uC549\uC544\uC11C"), /*#__PURE__*/React.createElement("tspan", {
    x: -40.201,
    y: 20
  }, "\uACE8\uACE0\uB8E8 \uBA39\uC5B4\uC694")), /*#__PURE__*/React.createElement("text", {
    id: "\\uBF40\\uB4DD\\uBF40\\uB4DD_\\uC190\\uBC1C_\\uC53B\\uACE0_\\uCE58\\uCE74\\uCE58\\uCE74_\\uC591\\uCE58\\uD574\\uC694_",
    "data-name": "\\uBF40\\uB4DD\\uBF40\\uB4DD \\uC190\\uBC1C \\uC53B\\uACE0 \\uCE58\\uCE74\\uCE58\\uCE74 \\uC591\\uCE58\\uD574\\uC694 ",
    transform: "translate(821 3285.5)",
    fill: "#484848",
    fontSize: 14,
    fontFamily: "NotoSansCJKkr-DemiLight, Noto Sans CJK KR DemiLight",
    fontWeight: 300
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -54.642,
    y: 0
  }, "\uBF40\uB4DD\uBF40\uB4DD \uC190\uBC1C \uC53B\uACE0"), /*#__PURE__*/React.createElement("tspan", {
    x: -53.081,
    y: 20
  }, "\uCE58\uCE74\uCE58\uCE74 \uC591\uCE58\uD574\uC694"), /*#__PURE__*/React.createElement("tspan", {
    fontFamily: "NotoSansCJKkr-DemiLight, Noto Sans CJK KR"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 40
  }))), /*#__PURE__*/React.createElement("text", {
    id: "\\uB0B4_\\uB9C8\\uC74C\\uC744_\\uC608\\uC058\\uAC8C_\\uC5B8\\uC5B4\\uB85C_\\uD45C\\uD604\\uD574\\uC694",
    "data-name": "\\uB0B4 \\uB9C8\\uC74C\\uC744 \\uC608\\uC058\\uAC8C \\uC5B8\\uC5B4\\uB85C \\uD45C\\uD604\\uD574\\uC694",
    transform: "translate(1016 3285.5)",
    fill: "#484848",
    fontSize: 14,
    fontFamily: "NotoSansCJKkr-DemiLight, Noto Sans CJK KR DemiLight",
    fontWeight: 300
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -48.202,
    y: 0
  }, "\uB0B4 \uB9C8\uC74C\uC744 \uC608\uC058\uAC8C"), /*#__PURE__*/React.createElement("tspan", {
    x: -46.641,
    y: 20
  }, "\uC5B8\uC5B4\uB85C \uD45C\uD604\uD574\uC694")), /*#__PURE__*/React.createElement("text", {
    id: "\\uCC45\\uC77D\\uB294_\\uC2DC\\uAC04\\uC774_\\uAE30\\uB2E4\\uB824\\uC838\\uC694",
    "data-name": "\\uCC45\\uC77D\\uB294 \\uC2DC\\uAC04\\uC774 \\uAE30\\uB2E4\\uB824\\uC838\\uC694",
    transform: "translate(1193 3285.5)",
    fill: "#484848",
    fontSize: 14,
    fontFamily: "NotoSansCJKkr-DemiLight, Noto Sans CJK KR DemiLight",
    fontWeight: 300
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -40.201,
    y: 0
  }, "\uCC45\uC77D\uB294 \uC2DC\uAC04\uC774"), /*#__PURE__*/React.createElement("tspan", {
    x: -32.2,
    y: 20
  }, "\uAE30\uB2E4\uB824\uC838\uC694")), /*#__PURE__*/React.createElement("text", {
    id: "\\uB2E4_\\uB180\\uACE0\\uB098\\uBA74_\\uD568\\uAED8_\\uC815\\uB9AC\\uD574\\uC694",
    "data-name": "\\uB2E4 \\uB180\\uACE0\\uB098\\uBA74 \\uD568\\uAED8 \\uC815\\uB9AC\\uD574\\uC694",
    transform: "translate(1377 3285.5)",
    fill: "#484848",
    fontSize: 14,
    fontFamily: "NotoSansCJKkr-DemiLight, Noto Sans CJK KR DemiLight",
    fontWeight: 300
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -33.761,
    y: 0
  }, "\uB2E4 \uB180\uACE0\uB098\uBA74"), /*#__PURE__*/React.createElement("tspan", {
    x: -40.201,
    y: 20
  }, "\uD568\uAED8 \uC815\uB9AC\uD574\uC694")))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContent3);
export default __webpack_public_path__ + "static/media/content3.0c6fac34.svg";
export { ForwardRef as ReactComponent };